import { useState } from "react";
import { Button, Modal, ModalClose, ModalDialog, ModalOverflow, Typography } from "@mui/joy";
import { LatLngExpression, LatLngLiteral } from "leaflet";
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet'

/*
type Latitude = string;
type Longitude = string;
type Position = [Latitude, Longitude];
*/

export function MapModal({ position }:{position:LatLngLiteral}) {
    const [open, setOpen] = useState<boolean>(false);

    const frameSrc = `https://www.openstreetmap.org/export/embed.html?bbox=${(position.lng - .001)},${(position.lat - .001)},${(position.lng + .001)},${(position.lat + .001)}&layer=mapnik&marker=${position.lat},${position.lng}`;
    // "https://www.openstreetmap.org/export/embed.html?bbox="+(position.lng - .001)+","+(position.lat - .001)+","+(position.lng + .001)+","+(position.lat + .001)+"&layer=mapnik&marker="+position.lat+","+position.lng}

    return (<>
        <a href="#" onClick={(e) => {e.preventDefault(); setOpen(true)}}>View Map</a>
        {/*
        <Button
            onClick={() => setOpen(true)}
            size="xs"
            variant="outlined"
        >
            View Map
        </Button>
        */}
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalOverflow>
            <ModalDialog
                // layout="fullscreen"
                size="lg"
                sx={{
                    width: '100%',
                    maxWidth: '40rem',
                }}
            >
                <ModalClose />

                <iframe
                    width="100%"
                    height="350"
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0"
                    src={frameSrc}>
                </iframe>
                {/*
                <br/>
                <small>
                    <a target="_blank" className="clickable" href="https://www.openstreetmap.org/?mlat={{position.lat}}&mlon={{position.lng}}#map=18/{{position.lat}}/{{position.lng}}">View Larger Map</a>
                </small>
                */}

                {/*
                <Typography>Coordinates</Typography>
                <MapContainer center={position} zoom={13} scrollWheelZoom={false}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={position}>
                    {/*
                    <Popup>
                        A pretty CSS3 popup. <br /> Easily customizable.
                    </Popup>
                    *\/}
                    </Marker>
                </MapContainer>
                */}
            </ModalDialog>
            </ModalOverflow>
        </Modal>
        </>);
}
